<div class="tab-pane" role="tabpanel" id="nuevas_normas">
        <fieldset id="agregar_tipocip" class="">
            <div class="step_section">
                <form [formGroup]="form">
                    <div class="row" id="row">
    
                        <div class="col-md-12" id="content">
                            <div class="alert alert-danger" role="alert" id="tp_find_alert" name="tp_find_alert" hidden>
                                <i class="fa fa-exclamation-triangle fa-2x" aria-hidden="true"></i>
                                <span id="tp_dir_message"></span>
                            </div>
                            <div class="form-horizontal">
                                <div class="form-group" align="left">
                                    <div class="col-sm-2">
                                        <label for="nuevas_normas">Se acoge a nuevas formas (AER. 5.1.18. O.G.U.C.)</label>
                                    </div>
                                    <div class="col-sm-3" align="left">
                                            <mat-radio-group formControlName="nuevas_normas" (change)="add_nuevas_normas()">
                                                <mat-radio-button style="padding-right: 20px" name="nuevas_normas" value="SI">SI</mat-radio-button>
                                                <mat-radio-button style="padding-right: 20px" name="nuevas_normas" value="NO">NO</mat-radio-button>
                                            </mat-radio-group>
                                    </div>
                                </div>
                            </div>
    
                        </div>
                    </div>
                </form>
            </div>
        </fieldset>
    </div>
    <div class="separator"></div>